import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('InvoiceFilter', InvoiceFilterData);

    InvoiceFilterData.$inject = ['DocumentFilter', 'INVOICE'];

    function InvoiceFilterData(DocumentFilter, INVOICE) {
        var InvoiceFilter = function() {
            DocumentFilter.call(this);
            this.setPage(INVOICE.pagination.defaultPage);
            this.setPageSize(INVOICE.pagination.defaultPageSize);
            this.setSorts(INVOICE.pagination.defaultSort);
            this.setOrderRefs = setOrderRefs;
        };

        InvoiceFilter.prototype = Object.create(DocumentFilter.prototype);

        return InvoiceFilter;

        /////////////////////

        function setOrderRefs(orderRefs) {
            this.commandsRef = orderRefs;
        }
    }
})();
